var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2104 13.2265C10.9041 12.9173 10.9041 12.416 11.2104 12.1069C11.5167 11.7977 12.0134 11.7977 12.3197 12.1069L15.457 15.2735C15.7633 15.5827 15.7633 16.084 15.457 16.3931C15.1507 16.7023 14.6541 16.7023 14.3478 16.3931L11.2104 13.2265Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13745 8.70834C3.13745 11.7689 5.59557 14.25 8.62781 14.25C11.66 14.25 14.1182 11.7689 14.1182 8.70834C14.1182 5.64776 11.66 3.16667 8.62781 3.16667C5.59557 3.16667 3.13745 5.64776 3.13745 8.70834ZM12.5495 8.70834C12.5495 10.8945 10.7937 12.6667 8.62781 12.6667C6.46192 12.6667 4.70613 10.8945 4.70613 8.70834C4.70613 6.52221 6.46192 4.75001 8.62781 4.75001C10.7937 4.75001 12.5495 6.52221 12.5495 8.70834Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03820c7ab0900598b12f0569d6280c81.svg";
export { ForwardRef as ReactComponent };